module.exports = __webpack_public_path__ + "logo_ucdavis-b0c03c770b1aa4b0fc82c12985094862.png";